import React, { Component } from 'react';
import PropTypes from 'prop-types';

import P from '@deliveroo/consumer-component-library/components/P';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Modal from '@deliveroo/consumer-component-library/components/Modal';

import i18n from '../../utils/i18n';

/**
 * A trigger component to open the CallRiderModal. Used on the Order Status page.
 */
export default class CallRiderModalButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contactRiderModal: false,
    };

    this.onContactRiderModalOpen = this.onContactRiderModalOpen.bind(this);
    this.onContactRiderModalClose = this.onContactRiderModalClose.bind(this);
  }

  onContactRiderModalOpen() {
    this.setState({
      contactRiderModal: true,
    });
  }

  onContactRiderModalClose() {
    this.setState({
      contactRiderModal: false,
    });
  }

  render() {
    const { children, riderNumber, modalText, modalHeader, appElement } = this.props;

    const contactModalTelLink = (
      <a key="contactModalTelLink" href={`tel:${riderNumber}`} target="_top">
        {riderNumber}
      </a>
    );
    const modalTextParts = modalText.split(riderNumber);
    const contactModalText = modalTextParts && [
      modalTextParts[0],
      contactModalTelLink,
      modalTextParts[1],
    ];

    return (
      <div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div onClick={this.onContactRiderModalOpen} role="button" tabIndex="0">
          {children}
        </div>

        <Modal
          id="search-modal"
          appElement={appElement}
          type="fullscreen"
          isOpen={this.state.contactRiderModal}
          onClose={this.onContactRiderModalClose}
          closeButtonLabel={i18n.gettext('closeButton.label')}
          headerTitle={modalHeader}
          renderFooter={() => (
            <Button type="primary" onClick={this.onContactRiderModalClose} isBlock>
              {i18n.gettext('Done')}
            </Button>
          )}
        >
          <P>{contactModalText}</P>
        </Modal>
      </div>
    );
  }
}

CallRiderModalButton.propTypes = {
  /**
   * The trigger for the modal. Flexible to allow a variety of elements to be
   * the trigger such as a button or a link.
   */
  children: PropTypes.node.isRequired,
  /**
   * The phone number of the rider.
   */
  riderNumber: PropTypes.string.isRequired,
  /**
   * The text for the modal header.
   */
  modalHeader: PropTypes.string.isRequired,
  /**
   * The text for the modal body. It will replace the first instance of the
   * phone number with a href that links to the phone number so that it can
   * be called if your device allows that (e.g. FaceTime on a Mac), otherwise
   * it defaults to regular text.
   */
  modalText: PropTypes.string.isRequired,
  /**
   * Allows you to specify the portion of your app that should be hidden
   * (via aria-hidden) to prevent assistive technologies such as screenreaders
   * from reading content outside of the content of your modal.
   * Also added so that it renders properly in Lemon.
   */
  appElement: PropTypes.string.isRequired,
};
